import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AccountSandbox } from '../account/account.sandbox';
import { USER_ROLES } from '../helpers/constants.enum';

@Injectable()
export class AdminGuard implements CanActivate {
    private currentRole: string = null;

    constructor(
        private router: Router,
        @Inject(PLATFORM_ID) private platformId: any,
        private snackBar: MatSnackBar,
        private accountSandbox: AccountSandbox
    ) {
        this.accountSandbox.currentUserRole$.subscribe(role => {
            this.currentRole = role;
        });
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
        if (this.currentRole && (this.currentRole === USER_ROLES.admin || this.currentRole === USER_ROLES.root )) {
            return true;
        } else {
            this.snackBar.open(
                'Unauthorized!', 'Close',
                {
                    horizontalPosition: 'end',
                    verticalPosition: 'bottom',
                    duration: 3000
                }
            );

            this.router.navigate(['/home']);
            return false;
        }
    }
}

